import React from "react";

import _ from "lodash";
import styled, { keyframes } from "styled-components";

import { Frame, TExtra } from "components/ui-kit/styled-templates";

import useElementSize from "hooks/useElementSize";

const { cos, sin, PI, random, round } = Math;

const sets = new Array(10).fill(0).map((i) => new Array(3).fill(0).map((i) => ({ startAngle: random() * 360, speed: random() })));

const angleFlucts = new Array(10).fill(0).map((i) => random());

const rotate = (startAngle: number) => keyframes`
    from {
        transform: rotate(${startAngle}deg);
    }
    to {
        transform: rotate(${360 + startAngle}deg);
    }
`;

type TProps = {
    rings?: number;
    contentArray?: Array<React.ReactNode>;
    children?: any;
    extra?: TExtra;
};

const SpinningCircles = (props: TProps) => {
    const { rings = 2, contentArray = [], children, extra } = props;

    const [wrapperRef, size] = useElementSize();

    const r = [1, 0.75, 0.58].map((i) => (i * Math.min(size.width, size.height)) / 2);
    try{
        if (window.innerWidth < 1000){
            return null;
        }
    }catch(exc){

    }

    return (
        <Frame ref={wrapperRef} extra={`position: relative; width: inherit; height: inherit; min-height: 300px; ${extra}`}>
            {r.slice(0, rings).map((item, index) => (
                <Ring key={index} radius={item} />
            ))}
            {r.slice(0, rings).map((radius, index) =>
                sets[index].map((item, index) => {
                    return (
                        <PlanetRing key={index} item={item} radius={radius}>
                            <Frame extra={`transform: translate(${radius * sin(2 * PI * 0)}px, ${radius * cos(2 * PI * 0)}px);`}>
                                <Planet />
                            </Frame>
                        </PlanetRing>
                    );
                }),
            )}
            {contentArray.map((component, index) => {
                const radius = r[index % (r.length - 1)];
                const angleDelta = 1 / contentArray.length;
                const phi = 2 * PI * (index * angleDelta - angleDelta * angleFlucts[index] * 0.3);
                return (
                    <Frame key={index} extra={`z-index: 1; transform: translate(${radius * sin(phi)}px, ${radius * cos(phi)}px);`}>
                        <Frame extra={`position: relative;`}>{component}</Frame>
                    </Frame>
                );
            })}
            {children && <Frame extra={`position: absolute;`}>{children}</Frame>}
        </Frame>
    );
};

const Planet = styled(Frame)`
    width: 34px;
    height: 34px;
    border-radius: 9999px;
    background: ${({ theme }) => _.shuffle([theme.blue, `#9CABD8`, `#2C3D56`])[0]};

    cursor: pointer;
    &:active {
        transform: scale(1.5);
    }
`;

const PlanetRing = styled(Frame)<{ radius: number; item: { speed: number; [key: string]: any } }>`
    width: ${({ radius }) => radius * 2}px;
    height: ${({ radius }) => radius * 2}px;
    border-radius: 50%;
    position: absolute;
    animation: ${({ item }) => rotate(item.startAngle)} ${({ item }) => item.speed * 200 + 10}s linear infinite;
`;

const Ring = styled(Frame)<{ radius: number }>`
    width: ${({ radius }) => radius * 2}px;
    height: ${({ radius }) => radius * 2}px;
    border: 2px solid ${({ theme }) => theme.blue};
    border-radius: 9999px;
    position: absolute;
`;

export default SpinningCircles;
